<template>
  <div class="icon">
    <svg class="icon_svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 70.402 70.402">
      <g id="Group_315" data-name="Group 315" transform="translate(-454.795 -96.788)">
        <circle id="Ellipse_234" data-name="Ellipse 234" cx="35.201" cy="35.201" r="35.201" transform="translate(454.795 96.788)" :class="['svg-fill--' + color]" />
        <g id="Group_314" data-name="Group 314">
          <path id="Path_478" data-name="Path 478" d="M491.713,138.162a5.547,5.547,0,0,0,.617-.363c.079-.052.153-.111.23-.167.131-.1.255-.2.375-.309a5.9,5.9,0,1,0-8.38-.768c.062.077.123.154.188.228.123.137.247.27.382.395a6.048,6.048,0,0,0,.546.451c.078.056.151.115.231.168a5.768,5.768,0,0,0,.623.365c-4.279,1.106-7.431,5.184-7.431,13.379h20.05C499.144,143.346,495.992,139.268,491.713,138.162Z" fill="#fff"/>
          <path id="Path_479" data-name="Path 479" d="M505.4,130.767a5.612,5.612,0,0,0,.6-.353c.085-.055.164-.116.245-.176.139-.1.27-.212.4-.326a5.9,5.9,0,1,0-8.352-.682c.031.038.061.075.093.112a6.247,6.247,0,0,0,.459.476c.105.1.218.182.329.271a5.762,5.762,0,0,0,.559.4c.157.1.312.2.479.281a8.636,8.636,0,0,0-2.322.99,7.521,7.521,0,0,1,.119.928,7.944,7.944,0,0,1-1.524,4.923,12.105,12.105,0,0,1,4.671,6.538h11.675C512.835,135.951,509.683,131.873,505.4,130.767Z" fill="#fff"/>
          <path id="Path_480" data-name="Path 480" d="M480.22,132.685a7.721,7.721,0,0,1,.12-.928,8.637,8.637,0,0,0-2.322-.99c.084-.042.161-.1.242-.142a5.882,5.882,0,0,0,1.046-.733l.034-.028a5.9,5.9,0,1,0-7.588.2c.035.029.069.058.1.086.149.115.3.226.458.326a5.611,5.611,0,0,0,.515.291c-4.279,1.106-7.431,5.184-7.431,13.379h11.675a12.105,12.105,0,0,1,4.671-6.538A7.951,7.951,0,0,1,480.22,132.685Z" fill="#fff"/>
          <path id="Path_481" data-name="Path 481" d="M491.713,119.9c.132-.065.252-.147.378-.222a5.755,5.755,0,0,0,.752-.531c.082-.068.168-.13.245-.2a5.982,5.982,0,0,0,.478-.5l.1-.127a5.892,5.892,0,1,0-9.022.107l.012.015a6.069,6.069,0,0,0,.529.547c.039.035.081.065.121.1a5.853,5.853,0,0,0,.891.627c.108.063.21.134.323.189a8.538,8.538,0,0,0-2.887,1.379,7.619,7.619,0,0,1,.584,4.417,7.8,7.8,0,0,1,4.9-1.741c.123,0,.248,0,.372.008a7.767,7.767,0,0,1,4.516,1.741,8.052,8.052,0,0,1-.1-1.218,7.859,7.859,0,0,1,.691-3.205A8.506,8.506,0,0,0,491.713,119.9Z" fill="#fff"/>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'purple-icon',
  props: ['color']
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .icon{
    display: flex; -js-display: flex;
    height: 100%;
    align-items: center;
  }

  .icon_svg{
    flex: 0 0 30px;
    height: 30px;
    width: 30px;
  }

  .cls-2{fill: $gray-lightest;}

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/assets/RepresentativeGovernmentIcon.vue